<template>
  <section>
        <b-card 
        style="width:100%">   
          <template v-slot:header >
            <div class="header-card">
              Garantias Pendientes
            </div>
          </template>
            <b-form  inline style="margin-bottom:15px;" novalidate >
              <b-row style="width:100%">  
                <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="orden_table"
                    route="ordenes_garantias"
                    dataRoute="ord_datosorden"
                    >
                      <template v-slot:modal>
                      <sw-modalregistrogarantia
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm"
                        >
                      </sw-modalregistrogarantia> 
                      <sw-modalrecibirgarantia
                        v-if="openModal.modal.modal==='Recibir'"
                        @save="saveForm"
                        >
                      </sw-modalrecibirgarantia>                     
                      <sw-modalentregagarantia
                        v-if="openModal.modal.modal==='Entregar'"
                        @save="saveForm"
                        >
                      </sw-modalentregagarantia>  
                    </template>
                  </sw-tableget>                  
                </b-col>                                     
              </b-row>             
           </b-form>                
         </b-card>  
  </section>
</template>

<script>
import SwSaveform from '@/components/forms/saveForm.vue'
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalentregagarantia from '@/components/modals/entregagarantia.vue'
import SwModalrecibirgarantia from '@/components/modals/recibirgarantia.vue'
import SwModalregistrogarantia from '@/components/modals/registrogarantia.vue'

export default { 
  name: "ord_datosgarantia",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
     SwInputs,
     ValidationObserver,     
     SwSaveform,
     SwTableget,
     SwModalentregagarantia,
     SwModalrecibirgarantia,
     SwModalregistrogarantia     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>
